<template>
  <div>
      <banner-top :text="titletext"></banner-top>
      <div class="bg"></div>
      <div>
        <!--
        <div class="flex">
          <div class="title">学校</div>
          <el-input placeholder="请输入" v-model="stuInfo.school"></el-input>
        </div>
        <div class="flex">
          <div class="title">班级</div>
          <el-input placeholder="请输入" v-model="stuInfo.classroom"></el-input>
        </div>
         -->
        <div class="flex">
          <div class="title">姓名</div>
          <el-input placeholder="请输入" v-model="stuInfo.name"></el-input>
        </div>
        <div class="flex">
          <div class="title">性别</div>
          <div class="gender">
            <div v-if="checked" >
                  <img @click="checked=false" src="../assets/icon34.png" alt="">
                  <span class="checkSpan">男</span>
            </div>
            <div v-if="!checked">
                <img @click="checked=false" src="../assets/icon33.png" alt="">
                <span class="checkSpan yellow">男</span>
            </div>
            <div v-if="!checked" >
                  <img @click="checked=true" src="../assets/icon34.png" alt="">
                  <span class="checkSpan">女</span>
            </div>
            <div v-if="checked">
                <img @click="checked=true" src="../assets/icon33.png" alt="">
                <span class="checkSpan yellow">女</span>
            </div>
          </div>
        </div>
        <div class="flex">
          <div class="title">身份证号</div>
          <el-input placeholder="请输入" v-model="stuInfo.id_no"></el-input>
        </div>
        <div class="flex">
          <div class="title">联系电话</div>
          <el-input placeholder="请输入" v-model="stuInfo.phone"></el-input>
        </div>
      </div>
      <div class="nav">
        <button @click="save">保存</button>
    </div>
  </div>
</template>

<script>
import bannerTop from '../components/BannerTop.vue'
import http from '../utils/http'

export default {
  name: 'changeStudents',
  components: { bannerTop },
  data () {
    return {
      checked: false,
      titletext: '学生信息',
      stuInfo: {
        id: '',
        // school: '',
        // classroom: '',
        name: '',
        gender: this.checked ? '1' : '2',
        id_no: '',
        phone: ''
      }
    }
  },
  methods: {
    save () {
      if (this.checked) {
        this.stuInfo.gender = 2
      } else {
        this.stuInfo.gender = 1
      }
      // if (!this.stuInfo.school || !this.stuInfo.classroom || !this.stuInfo.name) {
      if (!this.stuInfo.name) {
        this.$message.error('请填写学生信息')
        return
      }
      if (!/^\d{11}$/.test(this.stuInfo.phone)) {
        this.$message.error('请输入正确的电话号码')
        return
      }
      this.stuInfo.id_no = this.stuInfo.id_no.toUpperCase()
      if (this.stuInfo.id_no.startsWith('H') || this.stuInfo.id_no.startsWith('M')) {
        if (!/^[HM]{1}\d{8}$/.test(this.stuInfo.id_no)) {
          this.$message.error('请输入正确的港澳居民来往内地通行证号码')
          return
        }
      } else {
        if (!/^\d{17}[0-9X]/.test(this.stuInfo.id_no)) {
          this.$message.error('请输入正确的身份证号码')
          return
        }
      }

      http['put'](`students/${this.stuInfo.id}`, this.stuInfo).then(() => {
        this.$router.push({name: 'studentsInfo'})
      })
    }
  },
  created () {
    this.stuInfo = this.$route.query.item
    if (this.stuInfo.gender === 2) {
      this.checked = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg {
    position: absolute;
    width: 100%;
    height: 110%;
    top: -10%;
    background: #f5f5f5;
    z-index: -1;
}
.flex {
  width: 100%;
  height: 4rem;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px #ccc solid;
}
.flex .title {
  font-size: 20px;
  margin: 1.2rem;
}
.flex>>>.el-input {
  width: 14rem;
  margin-top: 0.7rem;
}
.flex>>>.el-input__inner {
  border: 0;
  font-size: 18px;
  text-align: right;
}
.gender {
  display: flex;
}
.gender img {
  width: 1.6rem;
  margin: 1rem;
}
.yellow {
  color: #ffb949!important;
}
.gender span {
  position: relative;
  top: -1.4rem;
  left: -0.6rem;
  color: #ccc;
}
.nav {
  width: 100%;
  height: 3.2rem;
  display: flex;
  position:fixed;
  justify-content: center;
  bottom: 0;
}
.nav button {
    width: 80%;
    height: 2.8rem;
    background: #ffb949;
    border-radius: 44px;
    border: 0;
    color: #fff;
    font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/order/changeStudents.vue